export default __webpack_public_path__ + "static/media/Tik-occhiolino.2d56dd36.svg";